import * as React from "react"
import { CookieSensitiveContentWrapper } from "../cookiebar"
import { Block } from "../library/container"
import { IframeBlockProps } from "./iframeBlockState"

export const IframeBlock: (props: IframeBlockProps) => JSX.Element = props => (
  <Block>
    <div className="block">
      <div className="container--mg align--center">
        <CookieSensitiveContentWrapper onChange={props.cookieUpdater}>
          <iframe width='100%' height='420' frameBorder='0' src={props.link} title="iframe"></iframe>
        </CookieSensitiveContentWrapper>
      </div>
    </div>
  </Block>
)
